export const LOG_INFO = "LOG_INFO";
export const LOG_SUCCESS = "LOG_SUCCESS";
export const LOG_WARNING = "LOG_WARNING";
export const LOG_ERROR = "LOG_ERROR";
